import React from "react";
import "./style.css";
import "../../../../../../tailwind.css";

import { Image } from "../../../../../../components/Image";
export const Price = ({sku, curPriceIndex, setCurPriceIndex, showDiscountInfo = true}) => {
  const renderDiscountInfo = (price, originPerDayClassName) => {
    const discountPercentText = price.getDiscountPercentText();
    const hasDiscount = price.hasDiscount();

    if (!showDiscountInfo || !hasDiscount) {
      return null;
    }

    return (
      <div className="flex flex-col items-end justify-center gap-[.4rem]">
        <div className="bg-[#FFAFAF33] rounded-[0.8rem] overflow-hidden">
          <div className="text-[1.1rem] text-[#F91D5F] font-bold px-[.4rem] py-[.2rem]">
            {discountPercentText}
          </div>
        </div>
        <div className={originPerDayClassName}>{price.getOriginPerDayPrice()}</div>
      </div>
    );
  };

  const renderPriceCard = (price, isSelected) => {
    const perPrice = price.getPerDayPriceWithoutUnit();
    const perPrices = perPrice.split(".");

    if (isSelected) {
      return renderSelectPriceCard(perPrices[0], perPrices[1]);
    }
    return renderUnselectPriceCard(perPrices[0], perPrices[1]);
  }


  const renderUnselectPriceCard = (price, price2) => {
    return <div className="plan-price-details-2">
      <div className="plan-price-breakdown">
        <div className="currency-symbol">
          <div className="currency-symbol-2">$</div>
        </div>

        <div className="price-value">{price}</div>

        <div className="price-breakdown">
          <div className="price-value-2">{price2}</div>

          <div className="price-frequency">per day</div>
        </div>
      </div>

      <Image src="/static/image/questionnaire/weight-loss/payScreen/rectangle-2858-3.png" alt="Rectangle" className="rectangle" />
    </div>
  }
  const renderSelectPriceCard = (price, price2) => {
    return <div className="plan-price-details-3">
      <div className="plan-price-breakdown">
        <div className="currency-symbol">
          <div className="currency-symbol-3">$</div>
        </div>

        <div className="price-value-3">{price}</div>

        <div className="price-breakdown">
          <div className="price-value-4">{price2}</div>

          <div className="price-frequency-2">per day</div>
        </div>
      </div>

      <Image src="/static/image/questionnaire/weight-loss/payScreen/rectangle-2858-4.png" alt="Rectangle" className="rectangle-2" />
    </div>
  }

  const renderSelectImage = (select) => {
    if (select) {
      return <Image src="/static/image/questionnaire/weight-loss/payScreen/icon-4.png" alt="Icon" className="icon" />;
    }
    return <Image src="/static/image/questionnaire/weight-loss/payScreen/icon-5.png" alt="Icon" className="icon" />;

  }
  if (!sku) {
    return ;
  }


  return (
      <div className="prices gap-[1rem]">
        {sku.prices?.map((price, index) => {
          if (index === 1) {
            return <div className={`card-2 ${curPriceIndex === 1 && "card-2-select"}`} onClick={() => {setCurPriceIndex(index)}} key={index}>
              <div className="most-popular-tag-wrapper">
                <div className="most-popular-tag">MOST POPULAR</div>
              </div>

              <div className="frame-7">
                <div className="plan-card">
                  {renderSelectImage(curPriceIndex === index)}

                  <div className="frame-10">
                    <div className="plan-title-3">{price.getFinalWeek()} Week Plan</div>

                    <div className="plan-price-details">
                      {price.hasDiscount() && <div className="plan-price-value-3">{price.getOriginPrice()}</div>}

                      <div className="plan-price-value-4">{price.getPrice()}</div>
                    </div>
                  </div>
                </div>

                <div className="frame-9">
                  {renderDiscountInfo(price, "plan-price-3")}
                  {renderPriceCard(price, curPriceIndex === index)}
                </div>
              </div>
            </div>;
          }

          return <div className={`card min-h-[88px] justify-center ${curPriceIndex === index && "card-select"}`} onClick={() => {setCurPriceIndex(index)}} key={index}>
            <div className="frame-7">
              <div className="plan-card">
                {renderSelectImage(curPriceIndex === index)}

                <div className="frame-8">
                  <div className="plan-details">
                    <div className="plan-title-2">
                      {price.dynamicCycleSubscription 
                        ? `${price.week} Week Trial` 
                        : `${price.getFinalWeek()} Week Plan`}
                    </div>
                    {price.dynamicCycleSubscription && <div className="plan-title-2-des">{price.getFinalWeek()} Week Plan</div>}

                  </div>

                  <div className="plan-price-details">
                    {price.hasDiscount() && <div className="plan-price-value">{price.getOriginPrice()}</div>}

                    <div className="plan-price-value-2">{price.getPrice()}</div>
                  </div>
                </div>
              </div>

              <div className="frame-9">
                {renderDiscountInfo(price, "plan-price-2")}
                {renderPriceCard(price, curPriceIndex === index)}
              </div>
            </div>
          </div>
        })}
      </div>
  );
};
